import React, { Fragment } from 'react'
import { func } from 'prop-types'
import { Row, Col } from '@paypalcorp/pp-react'
import serverData from '../../utils/server-data'
import { Sections } from '../../components'
import { privacySections, dataPlatformSections } from '../../config'

function iframeHeight() {
  const el = parent.document.querySelector('.rightSections iframe')
  if (el) {
    const height = el?.contentDocument?.body.scrollHeight
    el.style.height = height + 'px'
  }
}
const privacySectionsData = privacySections(serverData)

const MerchantSubHeader = ({ onSectionClick }) => {
  iframeHeight()

  return (
    <Row
      className={`one-section-only ${
        serverData.isNative ? 'merchant-zero-margin' : ''
      }`}
    >
      <Col>
        <Fragment>
          <Sections
            sections={privacySectionsData}
            onSectionClick={onSectionClick}
          />
          <Sections
            sections={dataPlatformSections}
            onSectionClick={onSectionClick}
          />
        </Fragment>
      </Col>
    </Row>
  )
}

MerchantSubHeader.propTypes = {
  onSectionClick: func.isRequired,
}

export default MerchantSubHeader
